import React, { useEffect, useState } from "react";
import IMAGES from "../../constant/IMAGES";
import TextHeader from "../TextHeader";
import useResponsive from "../../hooks/useResponsive";
import ModalFeature from "../Modal";

const items = [
  {
    image: IMAGES.tamLinh,
    title: "Tâm linh",
    desc: "Thể hiện lòng thành kính, tưởng nhớ và tri ân đối với tổ tiên, ông bà, cha mẹ và những người đã khuất.",
  },
  {
    image: IMAGES.daoDuc,
    title: "Đạo đức",
    desc: "Biểu hiện lòng biết ơn và đạo đức cao quý, góp phần gìn giữ chuẩn mực đạo đức trong xã hội.",
  },
  {
    image: IMAGES.ketNoi,
    title: "Kết nối",
    desc: "Tạo sự liên kết giữa con người với thế giới tâm linh, thể hiện niềm tin vào cõi âm và mong muốn cầu an cho người đã khuất.",
  },
  {
    image: IMAGES.nhanVan,
    title: "Nhân văn",
    desc: "Thúc đẩy lòng nhân ái, hướng con người đến những giá trị đạo đức tốt đẹp.",
  },
  {
    image: IMAGES.vanHoa,
    title: "Văn hóa",
    desc: "Nét đẹp truyền thống mang đậm dấu ấn tâm linh của người Việt.",
  },
  {
    image: IMAGES.truyenThong,
    title: "Truyền thống",
    desc: "Giữ gìn và phát huy bản sắc văn hóa dân tộc, thể hiện lòng hiếu thảo và sự trân trọng đối với thế hệ đi trước.",
  },
];

// const items = [
//   {
//     image: IMAGES.tamLinh1,
//     title: "Tâm linh",
//     desc: "Thể hiện lòng thành kính, tưởng nhớ và tri ân đối với tổ tiên, ông bà, cha mẹ và những người đã khuất.",
//   },
//   {
//     image: IMAGES.daoDuc1,
//     title: "Đạo đức",
//     desc: "Biểu hiện lòng biết ơn và đạo đức cao quý, góp phần gìn giữ chuẩn mực đạo đức trong xã hội.",
//   },
//   {
//     image: IMAGES.ketNoi1,
//     title: "Kết nối",
//     desc: "Tạo sự liên kết giữa con người với thế giới tâm linh, thể hiện niềm tin vào cõi âm và mong muốn cầu an cho người đã khuất.",
//   },
//   {
//     image: IMAGES.nhanVan1,
//     title: "Nhân văn",
//     desc: "Thúc đẩy lòng nhân ái, hướng con người đến những giá trị đạo đức tốt đẹp.",
//   },
//   {
//     image: IMAGES.vanHoa1,
//     title: "Văn hóa",
//     desc: "Nét đẹp truyền thống mang đậm dấu ấn tâm linh của người Việt.",
//   },
//   {
//     image: IMAGES.truyenThong1,
//     title: "Truyền thống",
//     desc: "Giữ gìn và phát huy bản sắc văn hóa dân tộc, thể hiện lòng hiếu thảo và sự trân trọng đối với thế hệ đi trước.",
//   },
// ];

const itemsMb = [
  {
    img: IMAGES.icon,
    title: "Tâm linh",
    desc: "Thể hiện lòng thành kính, tưởng nhớ và tri ân đối với tổ tiên, ông bà, cha mẹ và những người đã khuất.",
  },
  {
    img: IMAGES.icon3,
    title: "Kết nối",
    desc: "Tạo sự liên kết giữa con người với thế giới tâm linh, thể hiện niềm tin vào cõi âm và mong muốn cầu an cho người đã khuất.",
  },

  {
    img: IMAGES.icon1,
    title: "Văn hóa",
    desc: "Nét đẹp truyền thống mang đậm dấu ấn tâm linh của người Việt.",
  },
  {
    img: IMAGES.icon5,
    title: "Nhân văn",
    desc: "Thúc đẩy lòng nhân ái, hướng con người đến những giá trị đạo đức tốt đẹp.",
  },
  {
    img: IMAGES.icon2,
    title: "Đạo đức",
    desc: "Biểu hiện lòng biết ơn và đạo đức cao quý, góp phần gìn giữ chuẩn mực đạo đức trong xã hội.",
  },
  {
    img: IMAGES.icon4,
    title: "Truyền thống",
    desc: "Giữ gìn và phát huy bản sắc văn hóa dân tộc, thể hiện lòng hiếu thảo và sự trân trọng đối với thế hệ đi trước.",
  },
];

const SectionFeature2 = () => {
  const [angle, setAngle] = useState(0);
  const [radius, setRadius] = useState(0);
  const { isMobileOrTablet, isTabletOrLaptop } = useResponsive();
  const [show, setShow] = useState(false);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const updateRadius = () => {
      const newRadius = Math.min(window.innerWidth, window.innerHeight) * 0.5;
      setRadius(newRadius);
    };

    updateRadius();
    window.addEventListener("resize", updateRadius);
    return () => window.removeEventListener("resize", updateRadius);
  }, []);

  useEffect(() => {
    if (show) return; // Nếu modal mở, không chạy vòng lặp

    const interval = setInterval(() => {
      setAngle((prev) => prev + 1);
    }, 50);

    return () => clearInterval(interval);
  }, [show]); // Thêm `show` vào dependency array

  return (
    <div
      className="flex flex-col gap-8 xl:gap-0 xl:scroll-m-52 scroll-m-32"
      id="tinh-nang-doc-quyen"
    >
      <TextHeader text="TÍNH NĂNG ĐỘC QUYỀN" />
      <div className="relative h-screen w-[calc(100%+64px)] mix-blend-lighten overflow-hidden -mr-8 -ml-3 lg:flex hidden">
        <img
          src={IMAGES.orbitBg}
          alt="bg"
          className="absolute w-[90%] xl:w-[66%] top-1/2 left-[49%] -translate-x-1/2 -translate-y-1/2"
        />

        <div
          className="absolute w-[200px] h-[200px] 2xl:w-[260px] 2xl:h-[260px] left-1/2 top-[30%] aspect-square"
          style={{
            perspective: !isTabletOrLaptop ? "1100px" : "1000px",
            transform: "rotateX(-25deg) translate(-50%, -30%)",
            transformStyle: "preserve-3d",
          }}
        >
          {items.map((item, index) => {
            const theta =
              ((2 * Math.PI) / items.length) * index + (angle * Math.PI) / 360;
            const x = radius * 1.1 * Math.cos(theta);
            const z = radius * Math.sin(theta);

            return (
              <div
                key={index}
                className="absolute cursor-pointer"
                style={{
                  transform: `translate3d(${x}px, 0px, ${z}px)`,
                }}
                onClick={() => {
                  setShow(true);
                  setActive(index);
                }}
              >
                <img
                  src={item.image}
                  alt={`Image-${index}`}
                  className="w-full aspect-square object-cover"
                />
              </div>
            );
          })}
        </div>
      </div>

      {/*MOBILE and TABLET*/}
      <div className="relative w-full mix-blend-lighten block lg:hidden">
        <img src={IMAGES.orbitBgMB} alt="bg" className="w-full" />
        <div className="grid grid-cols-2 z-10 gap-8 sm:gap-24 absolute top-1/2 translate-y-[-50%] w-full">
          {itemsMb.map((item, index) => (
            <div
              key={index}
              className={`flex even:flex-row-reverse items-center gap-2 even:ml-auto odd:mr-auto group bg-no-repeat bg-[length:100%_100%] cursor-pointer w-full ${
                index % 2 ? "bg-bgNum2" : "bg-bgNum"
              }`}
              onClick={() => {
                setShow(true);
                setActive(index);
              }}
            >
              <img
                key={index}
                src={item.img}
                alt="item"
                className="size-[45px] sm:size-[85px]"
              />
              <p className="transition-all duration-700 ease-in-out text-sm sm:text-[28px]/[150%] text-[#F0D35A] font-semibold flex group-even:flex-row-reverse items-center gap-[10px]">
                {item.title}{" "}
              </p>
            </div>
          ))}
        </div>
      </div>
      {show && (
        <ModalFeature
          cotent={isMobileOrTablet ? itemsMb[active] : items[active]}
          onClose={() => setShow(false)}
          isClose={show}
        />
      )}
    </div>
  );
};

export default SectionFeature2;
